// TODO: update this app name
const APP_NAME = 'cmsc-sitemap-editor';

export const APP_CONTAINER = `${APP_NAME}-ct`;

/** App name used as the source identifier for fireTrackableEvent calls. */
export const TRACKING_APP_NAME = APP_NAME;

const NODE_ENV = process.env.NODE_ENV || 'development';
// TODO: move to secret
export const LAUNCHDARKLY_CLIENT_ID =
	NODE_ENV !== 'production'
		? '5a6a55245dc0730a17dbd39e'
		: '5a6a54ded2dfe40a43a34a83';
